/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

//import MyZzimNew from './MyZzimNew';
//import MyViewNew from './MyViewNew'
import { Helmet } from "react-helmet-async";

class Event extends Component {
  state = {
    //index: this.props.childProps.index ? this.props.childProps.index : 0,
    gubun: "ing",
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    con: 0,
  };
  componentDidMount = () => {
    this._getData(1);
  };

  _getData = async (gotoPage) => {
    const result = await this._getDataApi(gotoPage);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const eventList = result.data[0].listData;
    //console.log(eventList)
    //console.log(intReturn, con)

    if (intReturn === 0) {
      if (con > 0) {
        this.setState({
          gotoPage: gotoPage,
          con: con,
          pageCount: pageCount,
          eventList: eventList,
          refreshing: false,
        });
      } else {
        this.setState({
          gotoPage: 1,
          con: 0,
          eventList: null,
          refreshing: false,
        });
      }
    } else {
      this.setState({
        gotoPage: 1,
        con: 0,
        eventList: null,
        refreshing: false,
      });
    }
  };
  _getDataApi = (gotoPage) => {
    const { gubun, pageSize } = this.state;
    const { apiUrl } = this.props;
    //console.log(gubun)
    return axios
      .post(apiUrl + "/event", {
        params: {
          gubun: gubun,
          gotoPage: gotoPage,
          pageSize: pageSize,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
      });
  };
  _eventItem = (idx, url) => {
    const { setEventIdx, history } = this.props;
    const pos = url.indexOf("http");
    //console.log(idx)
    if (pos > -1) {
      window.open(url);
    } else {
      if (idx >= 288) {
        window.scrollTo(0, 0);
        history.push("/event/" + idx);
      } else {
        setEventIdx(idx);
      }
    }
  };
  _renderItem = () => {
    const { eventList } = this.state;

    //console.log('asdfasdklfjasdklfjlkasjdfkladsjlkfasdjfkl')
    const list = eventList.map((item, index) => {
      return (
        <ul onClick={() => this._eventItem(item.idx, item.linkUrl)} key={index}>
          <li className="date">{item.endDate}</li>
          <li className="thumb">
            {item.ingImg_mobile === undefined ||
            item.ingImg_mobile === "" ||
            item.ingImg_mobile === null ? (
              <img
                src={
                  "https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/event/" +
                  item.imgS
                }
              />
            ) : (
              <img
                src={"https://bc8azosk4j.ecn.cdn.ofs.kr/" + item.ingImg_mobile}
              />
            )}
          </li>
          <li className="info">
            <p className="type">{item.title}</p>
            <p className="subject">{item.comment}</p>
            <p className="duration">
              {item.startDate} ~ {item.endDate}
            </p>
          </li>
        </ul>
      );
    });

    return list;
  };
  _changeIndex = (gubun) => {
    this.setState({
      gubun,
      gotoPage: 1,
    });
    setTimeout(() => {
      this._getData(1);
    }, 700);

    //const { _myMenu } =this.props.childProps;
    //_myMenu(index)
  };
  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = 10; //한페이지에 보여질 레코드 갯수

    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    let pageCount1;

    if (pageCount > 10) {
      pageCount1 = 10;
    } else {
      pageCount1 = pageCount;
    }

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: "pointer" }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? "on" : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
      </Fragment>
    );
  };
  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn("페이지의 처음입니다.");
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn("페이지의 마지막입니다.");
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  render() {
    // const { index } = this.props.childProps;
    const { eventList, con, gubun } = this.state;
    //console.log(eventList)
    return (
      <Fragment>
        <Helmet>
          <title>이벤트 - 애니플러스</title>
          <meta name="title" content="이벤트 - 애니플러스" />
          <meta
            name="description"
            content="이벤트 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="이벤트, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션, "
          />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="이벤트 애니플러스 - 애니플러스" />
          <meta
            property="og:description"
            content="이벤트 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta property="og:url" content="https://www.aniplustv.com/event" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="이벤트 애니플러스 - 애니플러스" />
          <meta
            name="twitter:description"
            content="이벤트 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta
            name="twitter:domain"
            content="https://www.aniplustv.com/event"
          />

          <link rel="canonical" href="https://www.aniplustv.com/event" />
        </Helmet>
        <div className="content">
          <div className="event_wrap event_list">
            <div className="event_head">
              <h3>이벤트 </h3>
              <ul>
                <li>
                  <button
                    type="button"
                    onClick={() => this._changeIndex("ing")}
                    className={gubun === "ing" ? "active" : null}
                  >
                    진행중인 이벤트
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => this._changeIndex("end")}
                    className={gubun === "end" ? "active" : null}
                  >
                    종료된 이벤트
                  </button>
                </li>
              </ul>
            </div>

            <div className="list_wrap">
              <div className="listHead">
                <span className="total">
                  총 <em>{con}</em>개
                </span>
              </div>
              <div className="list">
                {eventList ? (
                  this._renderItem()
                ) : (
                  <ul>
                    <li className="date"></li>
                    <li className="thumb"></li>
                    <li className="info">
                      <p className="type">
                        {gubun === "ing" ? "진행중인 이벤트" : "종료된 이벤트"}
                      </p>
                      <p className="subject">
                        이벤트 내역이 존재하지 않습니다.
                      </p>
                      <p className="duration"></p>
                    </li>
                  </ul>
                )}
              </div>
              <div className="page_no">
                {eventList ? this._renderPage() : null}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(Event)));
